
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    
    

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      's182ab2d6c997515f': `Adja hozzá a kezdőképernyőjéhez a teljes élmény és a könnyű hozzáférés érdekében.`,
's224cbcec014ef6b5': `Nyomja meg a Megosztás gombot a navigációs sávban`,
's37a9e8aec5713460': `Több`,
's386eca8362ff6155': `Nyomja meg a Több gombot, ha nincs Megosztás ikon`,
's4e1e10a6ca408245': `Koppintson a "Hozzáadás a kezdőképernyőhöz" lehetőségre`,
's6196153c4b0c1ea0': `Telepítés`,
's633502f7cff4f847': `Nyissa meg a böngészője menüjét`,
's681e399d63311fba': `Galéria megjelenítése`,
's7f0591f08e318eda': `Nyomja meg a Több gombot a Megosztás menüben`,
's8114bd55cae5a22b': `Nyomja meg a Hozzáadás a Dock-hoz gombot`,
's922329d6f6213590': `Hozzáadás a Dock-hoz`,
's9af56bf005b49c74': `Görgessen le a "Hozzáadás a kezdőképernyőhöz" lehetőséghez`,
'sa5ef80b4bb9b39f8': `Kevesebb`,
'sba52286c21552a4e': `Telepítse eszközére a teljes élmény és a könnyű hozzáférés érdekében.`,
'sc16e00a7a8b2fde2': `Vissza`,
'scdaf4bbff76674c8': `Hozzáadás a kezdőképernyőhöz`,
'se0e473adfda8066c': `Nyissa meg a fő böngészőjében`,
'se740f75b95a51807': `Adja hozzá a Dock-hoz a teljes élmény és a könnyű hozzáférés érdekében.`,
'sfea652f6580ff086': `Ez az oldal alkalmazásfunkcióval rendelkezik.`,
    };
  